import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import '../../styles/Admin.css';

const JewelleryList = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    try {
      // Fetch all items including hidden ones
      const response = await axios.get('/api/jewellery?isAdmin=true');
      setItems(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching jewellery:", error);
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;
    try {
      await axios.delete(`/api/jewellery/${id}`);
      setItems(items.filter(item => item._id !== id));
    } catch (error) {
      console.error("Error deleting item:", error);
      alert("Error deleting item.");
    }
  };

  const handleStatusFilter = (status) => {
    setFilterStatus(status);
  };

  const filteredItems = items.filter(item => {
    const matchesStatus = filterStatus === 'All' || item.status === filterStatus;
    const matchesSearch = item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.karigar && item.karigar.toLowerCase().includes(searchTerm.toLowerCase()));
    return matchesStatus && matchesSearch;
  });

  const getStatusBadge = (status) => {
    switch (status) {
      case 'Available': return 'badge badge-success';
      case 'Reserved': return 'badge badge-reserved';
      case 'Sold': return 'badge badge-sold';
      case 'Hidden': return 'badge badge-hidden';
      case 'Draft': return 'badge badge-draft';
      default: return 'badge badge-secondary';
    }
  };

  if (loading) return <div className="admin-container">Loading Inventory...</div>;

  return (
    <div className="admin-container">
      <div className="admin-header">
        <h1>Inventory Management</h1>
        <Link to="/add-jewellery" className="btn-primary">+ Add New Item</Link>
      </div>

      {/* Controls */}
      <div className="dashboard-card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '20px 0', textAlign: 'left' }}>
        <div className="filter-group">
          {['All', 'Available', 'Reserved', 'Sold', 'Hidden', 'Draft'].map(status => (
            <button
              key={status}
              onClick={() => handleStatusFilter(status)}
              className={`btn-secondary ${filterStatus === status ? 'active' : ''}`}
              style={{
                marginRight: '5px',
                backgroundColor: filterStatus === status ? '#B8860B' : '#e2e3e5',
                color: filterStatus === status ? '#fff' : '#333'
              }}
            >
              {status}
            </button>
          ))}
        </div>
        <div className="search-box">
          <input
            type="text"
            placeholder="Search items, karigar..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
          />
        </div>
      </div>

      <div className="table-responsive">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Name</th>
              <th>Price & Weight</th>
              <th>Status</th>
              <th>Tags & Karigar</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredItems.map(item => (
              <tr key={item._id}>
                <td>
                  {item.image ? (
                    <img src={`/${item.image}`} alt={item.name} style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px' }} />
                  ) : (
                    <div style={{ width: '50px', height: '50px', background: '#ccc', borderRadius: '4px' }}></div>
                  )}
                </td>
                <td>
                  <strong>{item.name}</strong><br />
                  <small className="text-muted">{item.category} ({item.type})</small>
                </td>
                <td>
                  <div>₹{item.price.toLocaleString()}</div>
                  <small>{item.weight}g | {item.purity}</small>
                </td>
                <td>
                  <span className={`badge ${item.status === 'Sold' ? 'badge-danger' : 'badge-success'}`} style={{ padding: '4px 8px', borderRadius: '4px' }}>
                    {item.status}
                  </span>
                </td>
                <td>
                  {item.karigar && <div><small>Karigar: {item.karigar}</small></div>}
                  {item.tags && item.tags.map(tag => (
                    <span key={tag} className="badge badge-info" style={{ fontSize: '0.75rem', marginRight: '3px' }}>{tag}</span>
                  ))}
                </td>
                <td>
                  <Link to={`/edit-jewellery/${item._id}`} className="btn-secondary" style={{ marginRight: '5px', textDecoration: 'none', display: 'inline-block', fontSize: '0.85rem', padding: '4px 8px' }}>Edit</Link>
                  <button onClick={() => handleDelete(item._id)} className="btn-danger" style={{ border: 'none', padding: '4px 8px', borderRadius: '4px', cursor: 'pointer' }}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default JewelleryList;
